export default __webpack_public_path__ + "static/media/Features_HeroBanner_Image.285755e9.png";